function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F44336",
  d: "M4.882 13.816V1.731H.451c-.25 0-.451.202-.451.451v11.184c0 .248.202.45.45.45h4.432z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFC197",
  d: "M28.016 15.045v-1.07c0-.852-.69-1.543-1.543-1.543h-.876c.742-.053 1.329-.67 1.329-1.425V9.81c0-.79-.641-1.431-1.432-1.431h-1.226c.713 0 1.292-.578 1.292-1.292v-1.03c0-.714-.579-1.293-1.292-1.293h-1.189c.714 0 1.292-.579 1.292-1.293v-.769c0-.713-.578-1.292-1.292-1.292H5.719v12.494c2.005 0 3.616.201 4.907.55 4.133 1.116 4.993 3.733 4.993 6.027v4.223c0 .274.111.523.29.703.18.18.428.291.703.291 1.768 0 3.201-1.433 3.201-3.2v-4.137c0-.98.794-1.773 1.773-1.773h4.887c.852 0 1.543-.691 1.543-1.544z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F44336",
  d: "M8.734.283H3.437c-.25 0-.451.202-.451.451v14.079c0 .249.202.45.45.45h5.298c.249 0 .45-.201.45-.45V.734c0-.249-.201-.45-.45-.45z"
});

function SvgDislike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 26,
    fill: "none",
    viewBox: "0 0 29 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/Dislike.d6cd3492.svg";
export { ForwardRef as ReactComponent };